import { useParams } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { Text } from '@mantine/core';

import { useGetOrganisation } from 'api/organisations';
import { DataWrapper } from 'components/shared';
import {
  OrganisationViewCardSection,
  OrganisationViewWrapper,
} from 'components/Organisations';

import { CompanyData, CompanyDataSettings } from './CompanyData';
import { Delete } from './Delete';
import { GeneralSettings } from './GeneralSettings';

export const OrganisationDetails = () => {
  const { organisationId } = useParams();
  if (!organisationId) throw new Error('Missing URL params');

  const {
    data: organisationData,
    isError: isOrganisationError,
    isInitialLoading: isOrganisationInitialLoading,
  } = useGetOrganisation({
    pathParams: { organisationId },
  });

  const { t } = useTranslation('organisations');

  return (
    <DataWrapper
      data={organisationData}
      isError={isOrganisationError}
      isLoading={isOrganisationInitialLoading}
      errorMargin="xl"
    >
      {organisation => {
        const allCompanyDataFieldsEmpty = Object.entries(
          organisation.details,
        ).every(
          ([key, value]) => key === 'logoUrl' || value === null || value === '',
        );

        return (
          <OrganisationViewWrapper organisation={organisation}>
            <OrganisationViewCardSection
              title={t('organisationView.details.profile.title')}
              headerRight={<Text>ID: {organisationId}</Text>}
            >
              <GeneralSettings />
            </OrganisationViewCardSection>
            <OrganisationViewCardSection
              title={t('organisationView.details.companyData.title')}
              description={t(
                'organisationView.details.companyData.description',
              )}
              headerRight={<CompanyDataSettings organisation={organisation} />}
            >
              {!allCompanyDataFieldsEmpty && (
                <CompanyData organisation={organisation} />
              )}
            </OrganisationViewCardSection>
            {/* organisation.isAdministrator && (
              <OrganisationViewCardSection
                title={t('organisationView.details.delete.title')}
                description={t('organisationView.details.delete.description')}
                headerRight={<Delete organisation={organisation} />}
              />
            ) */}
          </OrganisationViewWrapper>
        );
      }}
    </DataWrapper>
  );
};
